import React from 'react';
import { authRoles } from 'app/auth';

// TODO Update path to use ID not name
export const StacksConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.admin,
	routes: [
		{
			path: '/stacks',
			component: React.lazy(() => import('./Stacks'))
		}
	]
};
